export default __webpack_public_path__ + "static/media/final.efb278cb.mp3";